import { media } from '@displate/styleguide';
import styled from 'styled-components';

import { TrustPilotStarProps } from '@/common/components/TrustpilotReviews/TrustpilotReviewStars';
import { customMediaQueries } from '@/common/constants/customMediaQueries';

export const TrustPilotStar = styled.img`
  && {
    opacity: ${(props: TrustPilotStarProps) => props.opacityValue};
    filter: ${(props: TrustPilotStarProps) => props.filter};
    height: 18px;
  }
`;

export const TrustpilotDrawerSubtitle = styled.div`
  && {
    font-size: ${({ theme }) => theme.fontSizesV2.titleBody12.lg};
  }
`;

export const NumberOfReviews = styled.div`
  && {
    font-size: ${({ theme }) => theme.fontSizesV2.titleBody14.lg};
    color: ${({ theme }) => theme.colorsV2.ui.general.primary};
    font-weight: bold;
    line-height: 20px;

    :hover {
      text-decoration: underline;
    }
  }
`;

export const TrustpilotReviewsHero = styled.div`
  && {
    cursor: pointer;
    div {
      margin-right: 8px;
      cursor: pointer;

      ${media.medium} {
        margin-bottom: 4px;
      }

      ${customMediaQueries.width1024} {
        margin-right: 0;
        text-align: end;
      }
    }
  }
`;
export const TrustpilotReviewStarsWrapper = styled.div`
  && {
    display: flex;
    align-items: center;
    gap: 2px;
    span {
      order: 1;
      display: inline-block;
      padding-left: 2px;
      font-size: ${({ theme }) => theme.fontSizesV2.titleBody14.lg};
      font-weight: 300;
      ${customMediaQueries.width1024} {
        order: 0;
        padding: 0 2px 0 0;
      }
    }
  }
`;
export const TrustpilotReviewLink = styled.a`
  && {
    display: block;
    margin-top: 12px;
    color: ${({ theme }) => theme.colorsV2.grayscale.black};
    font-size: ${({ theme }) => theme.fontSizesV2.titleBody16.lg};
    font-weight: 600;
  }
`;
export const TrustpilotReview = styled.div`
  && {
    margin: 8px 0 12px 0;
    color: ${({ theme }) => theme.colorsV2.grayscale.black};
    font-size: ${({ theme }) => theme.fontSizesV2.titleBody16.lg};
    font-weight: 300;
  }
`;
export const TrustpilotCustomerReview = styled.div`
  && {
    padding-bottom: 24px;
  }
`;
export const DrawerAggregatedScoreName = styled.div`
  && {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    font-size: ${({ theme }) => theme.fontSizesV2.titleBody14.lg};
    gap: 8px;
  }
`;
export const DrawerCustomHeaderLogo = styled.img`
  && {
    margin: 0 8px 16px 0;
    height: 24px;
  }
`;
export const DrawerCustomText = styled.div`
  && {
    font-size: ${({ theme }) => theme.fontSizesV2.titleBody18.lg};
    margin-bottom: 16px;
    font-weight: 600;
  }
`;

export const DrawerCustomHeader = styled.div``;
export const DrawerLogo = styled.div`
  && {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
`;
